import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuthContext } from "../auth/useAuthContext";
import { useLocales } from "./index";

export function useInitializeLanguage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { onChangeLang, currentLang } = useLocales();
  const { user } = useAuthContext();

  const isUrlProcessed = useRef(false);
  const lastSeenUserLang = useRef(null);

  useEffect(() => {
    const urlLang = searchParams.get("lang");

    if (urlLang && !isUrlProcessed.current) {
      isUrlProcessed.current = true;

      if (urlLang !== currentLang.value) {
        onChangeLang(urlLang);
      }

      searchParams.delete("lang");
      setSearchParams(searchParams, { replace: true });
      return;
    }

    if (user?.language && user.language !== lastSeenUserLang.current) {
      lastSeenUserLang.current = user.language;

      if (!isUrlProcessed.current && user.language !== currentLang.value) {
        onChangeLang(user.language);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, user?.language]);
}
